import {
	download_app,
	ENTITY_TYPE,
	IDENTIFIER_URL,
	investment_protection,
	login_to_online_banking,
	view_agreement
} from 'consts';

export const LINKS_AV = {
	download_app,
	login_to_online_banking,
	av_link: IDENTIFIER_URL
};

export const LINKS = {
	[ENTITY_TYPE.INDIVIDUAL]: [
		{
			download_app,
			login_to_online_banking
		},
		{
			view_agreement,
			investment_protection
		}
	],
	[ENTITY_TYPE.LEGAL_ENTITY]: [
		{
			link: IDENTIFIER_URL
		},
		{
			view_agreement,
			investment_protection
		}
	]
};

export const LINKS_ES_MV = [
	LINKS[ENTITY_TYPE.INDIVIDUAL][0],
	{
		...LINKS[ENTITY_TYPE.INDIVIDUAL][1],
		go_to_onboard_page: './onboard'
	}
];
